(() => {
  if (window.Shopify?.designMode) return;

  const isEditable = (target) =>
    target instanceof Element &&
    Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));

  document.addEventListener('contextmenu', (event) => {
    if (!isEditable(event.target)) event.preventDefault();
  });

  document.addEventListener(
    'keydown',
    (event) => {
      const key = event.key.toLowerCase();
      const blocksSource = event.ctrlKey && key === 'u';
      const blocksInspector =
        (event.ctrlKey || event.metaKey) && event.shiftKey && ['c', 'i', 'j'].includes(key);

      if (event.key === 'F12' || blocksSource || blocksInspector) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    { capture: true }
  );
})();
